/**
 * wql
 * @description 个人证书记录管理
 * @Date  2020/9/15
 */
import React from "react";
import {connect} from "dva";
import {templateConfig, reduxTemplateCofig} from "./config";
import {handleExportHeader} from '@/utils/handleTabelHeaderUtils';

import {component_tool, framework_tool, utils_tool} from '../../../tool';
import moment from "moment";

let {WizContainer, WizReduxTemplate,ossFileUtils} = framework_tool;
let {WizBrowserExport} = component_tool;
let {dateUtils} = utils_tool


class PersonalCertList extends WizContainer {
  componentName = 'personalCertList';

  constructor(props) {
    super(props);
    this.state = {}
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _getPathContent(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let columnDefs = [
        {
          headerName: '',
          width: 30,
          field: 'rowIndex',
          hidden: true,
          suppressMovable: true,
          cellStyle: {
            textAlign: 'center',
            padding: '5px 0',
            color: '#595959',
            backgroundColor: '#f0f0f0',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '500',
            boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
          },
        },
        {
          headerName: '姓名',
          field: 'fullName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '账号',
          field: 'userName',
          width: 30,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '账号状态',
          field: 'userState',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '身份证号',
          field: 'idCard',
          width: 25,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '手机号',
          field: 'mobile',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '任职',
          field: 'userIdentityInfoStr',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '证书名称',
          field: 'certName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '证书编号',
          field: 'certCode',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '证书状态',
          field: 'stateStr',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },

        {
          headerName: '证书类别',
          field: 'certType',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '颁发单位',
          field: 'awardUnit',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '有效开始日期',
          field: 'startDate',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '有效结束日期',
          field: 'endDate',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '复审日期',
          field: 'reCheckDate',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '初领日期',
          field: 'firstDate',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '获得途径',
          field: 'channel',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '数据来源',
          field: 'dataSourceStr',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '证书获取时间',
          field: 'certDate',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        
        {
          headerName: '最后更新时间',
          field: 'updateTime',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '证书照片（主）',
          field: 'imgMain',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'middle', horizontal: 'center'},
            font: {
              color: { argb: '0066FF' }
            },
          },
        },
        {
          headerName: '证书照片（副）',
          field: 'imgSecondary',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'middle', horizontal: 'center'},
            font: {
              color: { argb: '0066FF' }
            },
          },
        },
        {
          headerName: '邮寄申请状态',
          field: 'applyStatusStr',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '申请人',
          field: 'applyFullName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '申请人帐号',
          field: 'applyUserName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '申请时间',
          field: 'applyTimeStr',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '邮寄地址',
          field: 'address',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '收件人',
          field: 'touchPersonName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '联系电话',
          field: 'touchPhone',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '邮寄状态',
          field: 'postStatusStr',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '邮寄时间',
          field: 'postTimeStr',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '是否签收',
          field: 'signStatusStr',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '签收时间',
          field: 'signTimeStr',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        }
      ]
      let dataList = o.data
      dataList.forEach(e => {
        if (e.userState == 1) {
          e.userState = '激活'
        } else {
          e.userState = '禁用'
        }
        if (e.certType == 1) {
          e.certType = '培训证书';
        } else {
          e.certType = '社会证书';
        }
        if (e && e.certDetail){
          if (e.certDetail.imgMain!=null && e.certDetail.imgMain!=''){
            e.imgMain = getOssFilePath(e.certDetail.imgMain)
            if(e.imgMain){
              e.imgMain = e.imgMain +'?preview=true'
              e.imgMain = {text : e.imgMain ,hyperlink:e.imgMain}
            }
          }
          if (e.certDetail.imgSecondary!=null && e.certDetail.imgSecondary!=''){
            e.imgSecondary = getOssFilePath(e.certDetail.imgSecondary);
            if(e.imgSecondary){
              e.imgSecondary = e.imgSecondary +'?preview=true'
              e.imgSecondary = {text : e.imgSecondary ,hyperlink:e.imgSecondary}
            }
          }
          e.awardUnit = e.certDetail.awardUnit
          e.startDate = e.certDetail.startDate
          e.endDate = e.certDetail.endDate
          e.firstDate = e.certDetail.firstDate
          e.reCheckDate = e.certDetail.reCheckDate

        }
        e.certDate = dateUtils.formatDateString(e.certDate, 'yyyy-MM-dd');
      })
      WizBrowserExport({
        title: '个人证书记录',
        sheetName: '个人证书记录',
        columns: columnDefs.filter((_, index) => index),
        rows: dataList,
        filename: '个人证书记录.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _getPathContentNew(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let columnDefs = [
        {
          headerName: '',
          width: 30,
          field: 'rowIndex',
          hidden: true,
          suppressMovable: true,
          cellStyle: {
            textAlign: 'center',
            padding: '5px 0',
            color: '#595959',
            backgroundColor: '#f0f0f0',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '500',
            boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
          },
        },
        {
          headerName: '姓名',
          field: 'fullName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '账号',
          field: 'userName',
          width: 30,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '账号状态',
          field: 'userState',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '身份证号',
          field: 'idCard',
          width: 25,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '手机号',
          field: 'mobile',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '组织名称',
          field: 'orgName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '组织编码',
          field: 'orgCode',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '岗位名称',
          field: 'positionName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '证书名称',
          field: 'certName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '证书编号',
          field: 'certCode',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '证书状态',
          field: 'stateStr',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },

        {
          headerName: '证书类别',
          field: 'certType',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '颁发单位',
          field: 'awardUnit',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '有效开始日期',
          field: 'startDate',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '有效结束日期',
          field: 'endDate',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '复审日期',
          field: 'reCheckDate',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '初领日期',
          field: 'firstDate',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '获得途径',
          field: 'channel',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '数据来源',
          field: 'dataSourceStr',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '证书获取时间',
          field: 'certDate',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
       
        {
          headerName: '最后更新时间',
          field: 'updateTime',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '证书照片（主）',
          field: 'imgMain',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'middle', horizontal: 'center'},
            font: {
              color: { argb: '0066FF' }
            },
          },
        },
        {
          headerName: '证书照片（副）',
          field: 'imgSecondary',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'middle', horizontal: 'center'},
            font: {
              color: { argb: '0066FF' }
            },
          },
        },
        {
          headerName: '邮寄申请状态',
          field: 'applyStatusStr',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '申请人',
          field: 'applyFullName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '申请人帐号',
          field: 'applyUserName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '申请时间',
          field: 'applyTimeStr',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '邮寄地址',
          field: 'address',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '收件人',
          field: 'touchPersonName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '联系电话',
          field: 'touchPhone',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '邮寄状态',
          field: 'postStatusStr',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '邮寄时间',
          field: 'postTimeStr',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '是否签收',
          field: 'signStatusStr',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '签收时间',
          field: 'signTimeStr',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        }
      ]
      let dataList = o.data
      dataList.forEach(e => {
        if (e.userState == 1) {
          e.userState = '激活'
        } else {
          e.userState = '禁用'
        }
        if (e.certType == 1) {
          e.certType = '培训证书';
        } else {
          e.certType = '社会证书';
        }
        if (e && e.certDetail){
          if (e.certDetail.imgMain!=null && e.certDetail.imgMain!=''){
            e.imgMain = getOssFilePath(e.certDetail.imgMain)
            if(e.imgMain){
              e.imgMain = e.imgMain +'?preview=true'
              e.imgMain = {text : e.imgMain ,hyperlink:e.imgMain}
            }
          }
          if (e.certDetail.imgSecondary!=null && e.certDetail.imgSecondary!=''){
            e.imgSecondary = getOssFilePath(e.certDetail.imgSecondary);
            if(e.imgSecondary){
              e.imgSecondary = e.imgSecondary +'?preview=true'
              e.imgSecondary = {text : e.imgSecondary ,hyperlink:e.imgSecondary}
            }
          }
          e.awardUnit = e.certDetail.awardUnit
          e.startDate = e.certDetail.startDate
          e.endDate = e.certDetail.endDate
          e.firstDate = e.certDetail.firstDate
          e.reCheckDate = e.certDetail.reCheckDate

        }
        e.certDate = dateUtils.formatDateString(e.certDate, 'yyyy-MM-dd');
      })
      WizBrowserExport({
        title: '个人证书记录',
        sheetName: '个人证书记录',
        columns: columnDefs.filter((_, index) => index),
        rows: dataList,
        filename: '个人证书记录.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _exportDetailFile(nextProps, nextState, key) {
    const formatterDateTime = (val) => {
      return val ? moment(val).format('YYYYMMDDHHmm') : '';
    }
    let dateTime = formatterDateTime(new Date());
    let response = nextProps[key]
    const blob =response['result'];
    let link = document.createElement('a');
    let body = document.querySelector('body');

    //console.log("type==",blob['type'])
    if(blob['type']=="application/json") {
      //console.log("!!!!!!!!!!!!!!!!");
      const reader=new FileReader();
      reader.onload=function(){
      const {msg}= JSON.parse(reader.result);
      //console.log("msg==",msg);
      wizNotice.error(msg)
      };
      reader.readAsText(blob);
      return;
    }
    
    link.href = window.URL.createObjectURL(blob);
    link.download = '个人证书记录-'+dateTime+'.xls';

    // fix Firefox
    link.style.display = 'none';
    body.appendChild(link);

    link.click();
    body.removeChild(link);
  }

  _exportDetailByIdentityFile(nextProps, nextState, key) {
    let response = nextProps[key]
    const blob =response['result'];
    let link = document.createElement('a');
    let body = document.querySelector('body');
    const formatterDateTime = (val) => {
      return val ? moment(val).format('YYYYMMDDHHmm') : '';
    }
    let dateTime = formatterDateTime(new Date());

    //console.log("type==",blob['type'])
    if(blob['type']=="application/json") {
      //console.log("!!!!!!!!!!!!!!!!");
      const reader=new FileReader();
      reader.onload=function(){
      const {msg}= JSON.parse(reader.result);
      //console.log("msg==",msg);
      wizNotice.error(msg)
      };
      reader.readAsText(blob);
      return;
    }

    link.href = window.URL.createObjectURL(blob);
    link.download = '个人证书记录-按任职-'+dateTime+'.xls';

    // fix Firefox
    link.style.display = 'none';
    body.appendChild(link);

    link.click();
    body.removeChild(link);
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        enable: this._handleCMD,
        exportTrainPathInfo: this._exportTrainPathInfo,
        // export: this._getPathContent,
        // exportNew: this._getPathContentNew,
        export: this._exportDetailFile,
        exportNew: this._exportDetailByIdentityFile,
        updateState: this._handleCMD,
        del: this._handleCMD
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />

  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(PersonalCertList);
